// src/App.js
import React from "react";
import { Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
// ---- Pages ----
import Home from "./pages/Home";
import LearningZone from "./pages/LearningZone";
import BrainGames from "./pages/BrainGames";
import StoryWorld from "./pages/StoryWorld";
import CreativityStudio from "./pages/CreativityStudio";
import Profile from "./pages/Profile";
// import NotFound from "./pages/NotFound";

// ---- Components ----
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { ChildProgressProvider } from "./context/ChildProgressContext";
import { ActivityProvider } from "./context/ActivityContext";

function App() {
  return (<ActivityProvider>
  <AuthProvider>
    <ChildProgressProvider>
      <div className="app-container">
        <Navbar />

        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/learningzone" element={<LearningZone />} />
            <Route path="/braingames" element={<BrainGames />} />
            <Route path="/storyworld" element={<StoryWorld />} />
            <Route path="/creativitystudio" element={<CreativityStudio />} />
            <Route path="/profile" element={<Profile />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </ChildProgressProvider>
  </AuthProvider>
  </ActivityProvider>);
}

export default App;
